(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lim-event-detail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lim-event-detail')) {
    customElements.define('lim-event-detail', class extends HTMLElement {
      connectedCallback() {
        this.startedAt = performance.now();
        this.querySelectorAll('[data-event-datetime]').forEach(time => {
          const date = new Date(time.dateTime);
          if (Number.isFinite(date.getTime())) time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { timeZone: 'America/Los_Angeles', month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }).format(date);
        });
        this.refresh();
        this.timer = setInterval(() => this.refresh(), 30000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      refresh() {
        const now = Number(this.dataset.now) + (performance.now() - this.startedAt) / 1000;
        if (Number(this.dataset.end) <= now) {
          this.querySelectorAll('[data-event-rsvp]').forEach(element => { element.hidden = true; });
          if (this.dataset.registration !== 'cancelled') this.querySelector('[data-event-status]').textContent = this.dataset.pastLabel;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lim-event-registration"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lim-event-registration')) {
    customElements.define('lim-event-registration', class extends HTMLElement {
      connectedCallback() {
        this.startedAt = performance.now();
        this.refresh();
        this.timer = setInterval(() => this.refresh(), 30000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      refresh() {
        const now = Number(this.dataset.now) + (performance.now() - this.startedAt) / 1000;
        if (Number(this.dataset.end) <= now) {
          this.querySelectorAll('[data-event-rsvp]').forEach(element => { element.hidden = true; });
          const status = this.querySelector('[data-event-status]');
          if (status && this.dataset.registration !== 'cancelled') status.textContent = this.dataset.pastLabel;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lim-events-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lim-events-grid')) {
    customElements.define('lim-events-grid', class extends HTMLElement {
      connectedCallback() {
        this.startedAt = performance.now();
        this.controller = new AbortController();
        this.refresh();
        this.timer = setInterval(() => this.refresh(), 30000);
        this.loadRemaining();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.controller?.abort();
      }
      refresh() {
        const now = Number(this.dataset.now) + (performance.now() - this.startedAt) / 1000;
        const groups = { upcoming: [], past: [] };
        this.querySelectorAll('[data-event-card]').forEach(card => {
          const past = Number(card.dataset.end) <= now;
          const group = past ? 'past' : 'upcoming';
          const state = card.dataset.registration === 'cancelled' ? 'cancelled' : past ? 'past' : ['closed', 'sold_out'].includes(card.dataset.registration) ? card.dataset.registration : 'upcoming';
          const status = card.querySelector('[data-event-status]');
          if (status) status.textContent = this.dataset[state];
          const time = card.querySelector('time');
          if (time) time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { timeZone: 'America/Los_Angeles', month: 'long', day: 'numeric', year: 'numeric' }).format(new Date(Number(card.dataset.start) * 1000));
          groups[group].push(card);
        });
        for (const [group, cards] of Object.entries(groups)) {
          cards.sort((a, b) => group === 'past' ? Number(b.dataset.start) - Number(a.dataset.start) : Number(a.dataset.start) - Number(b.dataset.start));
          const container = this.querySelector(`[data-event-group="${group}"]`);
          cards.forEach((card, index) => {
            if (container.children[index] !== card) container.insertBefore(card, container.children[index] || null);
          });
          this.querySelector(`[data-empty="${group}"]`).hidden = cards.length > 0;
        }
      }
      async loadRemaining() {
        const more = this.querySelector('[data-more]');
        if (!more) return;
        let next = more.querySelector('a').href;
        const seen = new Set();
        try {
          while (next && !seen.has(next)) {
            seen.add(next);
            const url = new URL(next, location.origin);
            url.searchParams.set('section_id', this.dataset.section);
            const response = await fetch(url, { signal: this.controller.signal });
            if (!response.ok) throw new Error('Events could not load');
            const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
            const incoming = documentFragment.querySelector('lim-events-grid');
            if (!incoming) throw new Error('Events content missing');
            incoming.querySelectorAll('[data-event-card]').forEach(card => this.querySelector('[data-event-group="past"]').append(card));
            this.refresh();
            next = incoming.querySelector('[data-next-page]')?.getAttribute('href');
            if (next) more.querySelector('a').href = next;
          }
          more.hidden = true;
        } catch (error) {
          if (error.name !== 'AbortError') more.hidden = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
